module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAICAYAAACPp21mAAAAAXNSR0IArs4c6QAAAL1JREFUOE/N0iEOwkAQBdA/W9mz1a7pmlXVCAQWR1B1CCzJiB4ACzgcEtEDgCFZsSFhYUgTmiAa0iak7eif+S+TIfQ8zLxRSuVa62OXauoS/keWmZ8ASiKae+8La+29zd4hoPKBvQDsRWTqnDtlWfb4BR4SWrtKAGul1FJrXV27ccYArWEHEVlEUbRtAo8JWoEvRJSHEFZpmt6+T0vMXP9Mm5/uK3MGMInjeJckia9KxwoFEV1FpAghzIwx7g0A8kwJ5Rf6SwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductSelector/asstes/arrow2.png
// module id = Ex0j
// module chunks = 23